import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { V4Service } from 'src/app/services/v4.service';

@Component({
  selector: 'app-v2-paquetes',
  templateUrl: './v2-paquetes.component.html',
  styleUrls: ['./v2-paquetes.component.scss']
})
export class V2PaquetesComponent implements OnInit {
  paquetes: any[] = [];
  familias: any[] = [];
  productos: any[] = [];
  productosPaquete: any[] = [];
  filtro = '';

  formulario = { nombre: '', descripcion: '', precio: '', familia: '', activo: 1 };
  formularioEdit = { id: 0, nombre: '', descripcion: '', precio: '', familia: '', activo: 1 };
  paqueteSeleccionado: any = null;
  productoSeleccionado: any = '';
  productoInput = '';
  filtroProductoDisponible = '';
  filtroTipoProductoDisponible = '';
  filtroProductoPaquete = '';
  imagenPaqueteNueva: File | null = null;
  imagenPaqueteEditar: File | null = null;

  loading = false;

  constructor(
    private v4: V4Service,
    private iziToast: Ng2IzitoastService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getFamilias();
    this.getPaquetes();
    this.getProductos();
  }

  get paquetesFiltrados() {
    const term = this.filtro.toLowerCase();
    return this.paquetes.filter((p) => {
      const nombre = (p.nombre || '').toLowerCase();
      const descripcion = (p.descripcion || '').toLowerCase();
      const familia = this.getFamiliaNombre(p).toLowerCase();
      return nombre.includes(term) || descripcion.includes(term) || familia.includes(term);
    });
  }

  get productosDisponiblesFiltrados() {
    const term = (this.productoInput || this.filtroProductoDisponible).toLowerCase();
    const tipo = this.filtroTipoProductoDisponible.toLowerCase();
    const asignados = this.productosPaquete.map((item) => Number(item.producto));
    return this.productos.filter((producto) => {
      const nombre = (producto.nombre || '').toLowerCase();
      const descripcion = (producto.descripcion || '').toLowerCase();
      const tipoProducto = (producto.tipo || '').toLowerCase();
      const label = this.getProductoOptionLabel(producto).toLowerCase();
      const matchTexto = !term || nombre.includes(term) || descripcion.includes(term) || label.includes(term);
      const matchTipo = !tipo || tipoProducto.includes(tipo);
      const activo = producto.activo === undefined || producto.activo !== 0;
      return activo && matchTexto && matchTipo && !asignados.includes(Number(producto.id));
    });
  }

  get productosPaqueteFiltrados() {
    const term = this.filtroProductoPaquete.toLowerCase();
    return this.productosPaquete.filter((item) => {
      const detalle = item.producto_detalle || this.getProductoById(item.producto) || {};
      const nombre = (detalle.nombre || item.producto_nombre || '').toLowerCase();
      const descripcion = (detalle.descripcion || '').toLowerCase();
      const tipo = (detalle.tipo || item.producto_tipo || '').toLowerCase();
      return !term || nombre.includes(term) || descripcion.includes(term) || tipo.includes(term);
    });
  }

  get tiposProductosDisponibles() {
    return Array.from(new Set(this.productos.map((p) => p.tipo).filter((tipo) => !!tipo))).sort();
  }

  getFamiliaNombre(paquete: any): string {
    if (!paquete.familia) {
      return '';
    }
    const familia = this.familias.find((f) => Number(f.id) === Number(paquete.familia));
    return familia ? familia.nombre : '';
  }

  getProductoNombre(id: any): string {
    const p = this.getProductoById(id);
    return p ? p.nombre : '-';
  }

  getProductoImagen(id: any): string | null {
    const p = this.getProductoById(id);
    if (p?.imagen) {
      return p.imagen;
    }
    const galeria = p?.imagenes || [];
    const activa = galeria.find((img) => img.activo !== 0);
    return activa?.imagen || null;
  }

  getProductoDescripcion(id: any): string {
    const p = this.getProductoById(id);
    return p ? (p.descripcion || '') : '';
  }

  getProductoTipo(id: any): string {
    const p = this.getProductoById(id);
    return p ? (p.tipo || '') : '';
  }

  getFamilias(): void {
    this.v4.getFamilias().subscribe(
      (data: any) => {
        if (data.success) {
          this.familias = data.content || [];
        }
      },
      (error) => console.error(error)
    );
  }

  getPaquetes(): void {
    this.loading = true;
    this.v4.getPaquetes().subscribe(
      (data: any) => {
        this.loading = false;
        if (data.success) {
          this.paquetes = data.content || [];
        }
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  agregarPaquete(): void {
    this.v4.crearPaquete({ ...this.formulario, imagen: this.imagenPaqueteNueva }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Paquete creado');
          this.formulario = { nombre: '', descripcion: '', precio: '', familia: '', activo: 1 };
          this.imagenPaqueteNueva = null;
          this.getPaquetes();
        }
      },
      (error) => console.error(error)
    );
  }

  abrirEditar(modal: any, paquete: any): void {
    this.formularioEdit = {
      id: paquete.id,
      nombre: paquete.nombre,
      descripcion: paquete.descripcion || '',
      precio: paquete.precio || '',
      familia: paquete.familia ? paquete.familia : '',
      activo: paquete.activo === 0 ? 0 : 1
    };
    this.imagenPaqueteEditar = null;
    this.modalService.open(modal, { ariaLabelledBy: 'modal-editar-paquete' });
  }

  actualizarPaquete(): void {
    this.v4.actualizarPaquete(this.formularioEdit.id, {
      nombre: this.formularioEdit.nombre,
      descripcion: this.formularioEdit.descripcion,
      precio: this.formularioEdit.precio,
      familia: this.formularioEdit.familia,
      activo: this.formularioEdit.activo,
      imagen: this.imagenPaqueteEditar
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Paquete actualizado');
          this.modalService.dismissAll();
          this.imagenPaqueteEditar = null;
          this.getPaquetes();
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarPaquete(id: number): void {
    if (!confirm('Eliminar paquete?')) {
      return;
    }
    this.v4.eliminarPaquete(id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Paquete eliminado');
          this.getPaquetes();
        }
      },
      (error) => console.error(error)
    );
  }

  getProductos(): void {
    this.v4.getProductos().subscribe(
      (data: any) => {
        if (data.success) {
          this.productos = data.content || [];
        }
      },
      (error) => console.error(error)
    );
  }

  abrirProductos(modal: any, paquete: any): void {
    this.paqueteSeleccionado = paquete;
    this.productoSeleccionado = '';
    this.productoInput = '';
    this.filtroProductoDisponible = '';
    this.filtroTipoProductoDisponible = '';
    this.filtroProductoPaquete = '';
    this.productosPaquete = [];
    this.loadProductosPaquete(paquete.id);
    this.modalService.open(modal, { ariaLabelledBy: 'modal-productos-paquete', size: 'lg' });
  }

  agregarProductoPaquete(): void {
    const productoId = this.getProductoIdFromInput(this.productoInput) || this.productoSeleccionado;
    if (!this.paqueteSeleccionado || !productoId) {
      return;
    }
    this.v4.agregarPaqueteProducto({
      paquete: this.paqueteSeleccionado.id,
      producto: productoId,
      activo: 1
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Producto agregado al paquete');
          this.productoSeleccionado = '';
          this.productoInput = '';
          this.loadProductosPaquete(this.paqueteSeleccionado.id);
        }
      },
      (error) => console.error(error)
    );
  }

  toggleProductoPaquete(item: any): void {
    if (!this.paqueteSeleccionado) {
      return;
    }
    const activo = item.activo === 0 ? 1 : 0;
    this.v4.actualizarPaqueteProducto(item.id, {
      paquete: item.paquete || this.paqueteSeleccionado.id,
      producto: item.producto,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          item.activo = activo;
          this.toast(activo ? 'Producto activado en paquete' : 'Producto desactivado en paquete');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarProductoPaquete(item: any): void {
    if (!confirm('Eliminar producto del paquete?')) {
      return;
    }
    this.v4.eliminarPaqueteProducto(item.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Producto eliminado del paquete');
          if (this.paqueteSeleccionado) {
            this.loadProductosPaquete(this.paqueteSeleccionado.id);
          }
        }
      },
      (error) => console.error(error)
    );
  }

  loadProductosPaquete(paqueteId: number): void {
    this.v4.getPaqueteProductos(paqueteId).subscribe(
      (data: any) => {
        if (data.success) {
          this.productosPaquete = data.content || [];
        }
      },
      (error) => console.error(error)
    );
  }

  onFileChangeNuevo(event: any): void {
    const file = event.target.files[0];
    this.imagenPaqueteNueva = file || null;
  }

  onFileChangeEditar(event: any): void {
    const file = event.target.files[0];
    this.imagenPaqueteEditar = file || null;
  }

  onProductoInputChange(value: string): void {
    this.productoInput = value;
    this.productoSeleccionado = this.getProductoIdFromInput(value) || '';
  }

  getProductoOptionLabel(producto: any): string {
    return `${producto.id} - ${producto.nombre || ''}${producto.tipo ? ' - ' + producto.tipo : ''}`;
  }

  private getProductoById(id: any): any {
    return this.productos.find((prod) => Number(prod.id) === Number(id));
  }

  private getProductoIdFromInput(value: string): number | null {
    const parsed = Number(String(value || '').split(' - ')[0]);
    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }
    const match = this.productosDisponiblesFiltrados.find((producto) => {
      return (producto.nombre || '').toLowerCase() === String(value || '').toLowerCase();
    });
    return match ? Number(match.id) : null;
  }

  private toast(title: string): void {
    this.iziToast.show({
      title,
      titleColor: '#f8f8ff',
      color: '#4CAF50',
      position: 'topRight',
      closeOnEscape: true
    });
  }
}
